import React, { useState } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import HighlightOffRoundedIcon from "@material-ui/icons/HighlightOffRounded";
import { changeSelectedSymptomsAction } from "../../../../../../../reducers/searchOmimState";
import Grid from "@material-ui/core/Grid";
import AlertDialog from "../../../../../../common/AlertDialog";

const useStyles = makeStyles((theme) => ({
  container: {
    height: "100%",
    display: "grid",
    paddingRight: "1rem",
  },
  symptomBlock: {
    display: "flex",
    alignItems: "center",
  },
  symptom: {
    borderRadius: 30,
    padding: theme.spacing(1, 2),
    backgroundColor: "#F3F2FC",
    border: "1px solid #FFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    width: "100%",
  },
  symptomGridItem: {
    padding: theme.spacing(0, 1),
  },
  selectedSymptomName: {
    textOverflow: "ellipsis",
    maxWidth: 200,
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  iconsContainer: {
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  synonymTitle: {
    color: "black",
    marginBottom: theme.spacing(2),
  },
  modalTitle: {
    padding: theme.spacing(3),
    color: theme.palette.secondary.main,
    wordBreak: "break-word",
  },
  modalButton: {
    margin: theme.spacing(2),
    border: "1px solid #FFF",
    backgroundColor: "#F3F2FC",
    borderRadius: 30,
    cursor: "pointer",
    padding: theme.spacing(1, 3),
    color: theme.palette.text.main + "!important",
    textTransform: "capitalize",
    "&:hover": {
      border: "1px solid #FF3185",
      backgroundColor: "#FFF6FA",
    },
  },
}));

const SelectedSymptomsComponent = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();

  const { selectedSymptoms } = useSelector((state) => state.searchOmim);

  const [symptom, setSymptom] = useState(null);

  const handleOpenSymptomModal = (symptom) => {
    setSymptom(symptom);
  };

  const handleCloseSymptomModal = () => {
    setSymptom(null);
  };

  const handleRemoveSymptom = (symptom) => {
    const newSymptoms = selectedSymptoms.filter((s) => s.id !== symptom.id);
    dispatch(changeSelectedSymptomsAction(newSymptoms));
  };

  return (
    <>
      <Typography variant={"h2"}>{intl.formatMessage({ id: "selected_symptoms_and_signs" })}</Typography>
      <div className={classes.container}>
        {selectedSymptoms.map((s) => (
          <div className={classes.symptomBlock} key={s.id}>
            <div key={s.id} className={classes.symptom}>
              <div className={classes.symptomdivItem}>
                <Typography className={classes.selectedSymptomName}>{s.name}</Typography>
              </div>
            </div>
            <div className={classes.iconsContainer}>
              <IconButton onClick={() => handleOpenSymptomModal(s)}>
                <VisibilityOutlinedIcon color={"secondary"} />
              </IconButton>
              <IconButton onClick={() => handleRemoveSymptom(s)}>
                <HighlightOffRoundedIcon />
              </IconButton>
            </div>
          </div>
        ))}
      </div>
      <AlertDialog
        open={!!symptom}
        buttonCloseText={intl.formatMessage({ id: "global_buttons_close" })}
        description={
          <>
            <Typography variant={"h5"} className={classes.synonymTitle}>
              {intl.formatMessage({ id: "searchOmimComponent.synonyms" })}
            </Typography>
            <Grid container spacing={4}>
              {symptom?.synonyms?.map((synonym) => (
                <Grid item sm={12} md={3} key={synonym}>
                  <Typography className={classes.synonym}>{synonym}</Typography>
                </Grid>
              ))}
            </Grid>
          </>
        }
        title={
          <Typography variant={"h4"} className={classes.modalTitle}>
            {symptom?.name}
          </Typography>
        }
        onClose={handleCloseSymptomModal}
        buttonClassName={classes.modalButton}
      />
    </>
  );
};

export default SelectedSymptomsComponent;
